import moment from 'moment-timezone';

const TZ = process.env.REACT_APP_TZ || 'America/Santiago';

export const getCountry = () => {
  if (typeof window !== 'undefined') {
    const country = window.location.host.split('.');
    if (!['pe', 'co', 'cl'].includes(country[country.length - 1])) return 'cl';
    return country[country.length - 1];
  }
  return 'cl';
};

const toPercentage = (value: any) => {
  if (value !== undefined && value !== null) {
    let r = value.toString().replace(/[^0-9.]/g, '');
    if (r) {
      return r;
    }
    return '';
  }
  return '';
};

const toPrice = (value: any) => {
  if (value !== undefined && value !== null) {
    if (value > 0) {
      let val = value.toString().replace(/[$.,]/g, '');
      return '$' + val.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    return 'Sin Oferta';
  }
  return 'Sin Oferta';
};

const toNumber = (value: any) => {
  if (value !== undefined && value !== null) {
    return value
      .toString()
      .replace(/[^0-9]/g, '')
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
  }
  return '';
};

const cleanNumber = (value: any) => {
  if (value !== undefined && value !== null) {
    return value.toString().replace(/[^0-9]/g, '');
  }
  return '';
};

const cleanNumberTest = (value: any) => {
  if (![undefined, null, '$', ''].includes(value)) {
    let temp = value.toString().replace(/[^0-9]/g, '');
    if (temp !== '') {
      return parseInt(temp);
    }
  }
  return '';
};

const getStatusName = (value: any) => {
  if ([1, 2].includes(parseInt(value))) return 'Sin enviar';
  if ([3, 4, 5, 6, 7, 8, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 24].includes(parseInt(value))) return 'Solicitud abierta';
  if ([20].includes(parseInt(value))) return 'Aceptada';
  if ([21, 22, 23].includes(parseInt(value))) return 'Abandonada';
  if ([25].includes(parseInt(value))) return 'En carta de toma';
  if ([9].includes(parseInt(value))) return 'Rechazada';
  return '';
};

const toRut = (value: any, country: any) => {
  if (country === 'pe') {
    return value;
  }
  var rutAndDv = splitRutAndDv(value.substring(0, 12));
  var cRut = rutAndDv[0];
  var cDv = rutAndDv[1];
  if (!(cRut && cDv)) {
    return cRut || value;
  }
  var rutF = '';
  var thousandsSeparator = '.';
  while (cRut.length > 3) {
    rutF = thousandsSeparator + cRut.substr(cRut.length - 3) + rutF;
    cRut = cRut.substring(0, cRut.length - 3);
  }
  value = cRut + rutF + '-' + cDv;
  return value;
};

const empty = (value: any) => {
  let cache;
  if ((cache = typeof value) !== 'boolean' && (cache !== 'number' || isNaN(value)) && !value) return true;
  if (cache === 'string' && value.replace(/\s/g, '').length === 0) return true;
  if (cache === 'object') {
    if ((cache = toString.call(value)) === '[object Array]' && value.length === 0) return true;
    if (cache === '[object Object]') {
      for (cache in value) {
        return false;
      }
      return true;
    }
  }
  return false;
};

const getOriginName = (value: any) => {
  if (parseInt(value) === 0) {
    return 'Sucursales';
  }
  if (parseInt(value) === 1) {
    return 'Web';
  }
  if (parseInt(value) === 2) {
    return 'Api';
  }
  return '';
};

const getPureTypeName = (value: any) => {
  if (value === 'f' || value === false) {
    return 'Retoma';
  }
  if (value === 't' || value === true) {
    return 'Compra Pura';
  }
  return '';
};

const showRange = (min: any, max: any, type: any) => {
  if (type === 'price') {
    if (min && max) {
      return `Entre ${toPrice(min)} y ${toPrice(max)}`;
    }
    if (!min && max) {
      return `Hasta ${toPrice(max)}`;
    }
    if (min && !max) {
      return `Desde ${toPrice(min)}`;
    }
  }
  if (type === 'age') {
    if (min && max) {
      return `${min} - ${max}`;
    }
    if (!min && max) {
      return `0 - ${max}`;
    }
    if (min && !max) {
      return `${min} - 15`;
    }
    if (!min && !max) {
      return `0 - 15`;
    }
  }
  if (type === 'km') {
    if (min && max) {
      return `${toNumber(min)} - ${toNumber(max)}`;
    }
    if (!min && max) {
      return `0 - ${toNumber(max)}`;
    }
    if (min && !max) {
      return `Desde ${toNumber(min)}`;
    }
    if (!min && !max) {
      return ` - `;
    }
  }
  return '';
};

const getTraction = (value: any) => {
  if (value === 0 || value === '0') {
    return '4x2';
  }
  if (value === 1 || value === '1') {
    return '4x4';
  }
  return '';
};

const getTransmission = (value: any) => {
  if (value === 0 || value === '0') {
    return 'Mecánico';
  }
  if (value === 1 || value === '1') {
    return 'Automático';
  }
  return '';
};

const getTechicalDetails = (value: any) => {
  if (value === 0 || value === '0') {
    return 'Bueno';
  }
  if (value === 1 || value === '1') {
    return 'Dañado';
  }
  return '';
};

const getInspectionStatuses = (value: any) => {
  if (value) {
    return `${value} de 5`;
  }
  return 'Sin información';
};

const getDateValue = (value?: string) => {
  if (value) {
    const cleanValue = value.replace(/([+-]\d{2}:\d{2})$/, ''); // FIXME: Parche para quitar el offset de la fecha, remover en el futuro.
    return moment.parseZone(cleanValue).tz(TZ).format('DD-MM-YYYY - HH:mm');
  }
  return '';
};

const setInspectorvalue = (value: any) => {
  if (value) return value;
  return 'Por asignar';
};

const getVehicleInfo = (vehicleType: any, value: any) => {
  if (vehicleType[value]) return vehicleType[value].name;
  return '';
};

const getConsignment = (value: any) => {
  if (value === false) return 'No';
  if (value === true) return 'Si';
  return '';
};

const formatter = {
  getDateValue,
  getInspectionStatuses,
  getTechicalDetails,
  getTransmission,
  getTraction,
  showRange,
  getPureTypeName,
  getOriginName,
  empty,
  toRut,
  getStatusName,
  cleanNumberTest,
  cleanNumber,
  toNumber,
  toPrice,
  toPercentage,
  getCountry,
  setInspectorvalue,
  getVehicleInfo,
  getConsignment
};

export default formatter;

function splitRutAndDv(rut: any) {
  var cValue = rut.replace(/[.-]/g, '');
  if (cValue.length === 0) {
    return [null, null];
  }
  if (cValue.length === 1) {
    return [cValue, null];
  }
  var cDv = cValue.charAt(cValue.length - 1);
  var cRut = cValue.substring(0, cValue.length - 1);
  return [cRut, cDv];
}
